import React from "react";
import { useTranslation } from "react-i18next";

//IMG
import servicesImg from "../../../public/assets/images/altrePag/servizi.jpg";


const ServicesMain: React.FC = () => {

    const { t } = useTranslation();

    const services = [
        {
            title: t('servicesPage.liTitle1'),
            description: t('servicesPage.liDesc1')
        },
        {
            title: t('servicesPage.liTitle2'),
            description: t('servicesPage.liDesc2')
        },
        {
            title: t('servicesPage.liTitle3'),
            description: t('servicesPage.liDesc3')
        },
        {
            title: t('servicesPage.liTitle4'),
            description: t('servicesPage.liDesc4')
        },
        {
            title: t('servicesPage.liTitle5'),
            description: t('servicesPage.liDesc5')
        },
        {
            title: t('servicesPage.liTitle6'),
            description: t('servicesPage.liDesc6')
        }
    ]
    
    return(
        <section>
            <div className="row justify-content-center mb-4 mb-xl-5">
                <div className="col-12">
                    <div className="intro">
                        <p className="mb-4 m-lg-auto" dangerouslySetInnerHTML={{ __html: t('servicesPage.para1') as string }} />
                    </div>
                    <img src={servicesImg} className="img-fluid" alt={`${t('servicesPage.altImg')}`} style={{width:"100%", maxHeight: "550px", objectFit: "cover"}} />
                </div>
            </div>
            <ul className="row list-unstyled">
            {services.map((service, index) => (
                <li key={index} className="col-12 col-md-6 col-xl-4 mb-4">
                    <div className="text-center service-card">
                        <h3>{service.title}</h3>
                        <p className="m-0 p-3" dangerouslySetInnerHTML={{ __html: service.description as string }} />
                    </div>
                </li>
            ))}
            </ul>
        </section>
    )
};
export default ServicesMain;